// @flow
import React, { Component } from 'react';
import { AnyAction } from 'redux';
import { connect } from 'react-redux';
import { sanitizeRouteParams } from 'metaup/routing/routingUtils';
import type { Routes } from 'metaup/routing/routingUtils';
import { listOfflineBranches } from './model/OfflineBranch.client';
import ErrorCapsule from '../core/exceptions/ErrorCapsule';
import OfflineBranchesPageView from './views/OfflineBranchesPageView';
import type { OfflineBranchesPageViewProps } from './views/OfflineBranchesPageView';

const branchShape = `{
  officeId officeName isOnline lastSeenAt lastSyncAt
  appVersion deviceInfo tokenIsActive lastDate cutsLastDay
}`;

// Приложения отмечаются раз в 30 секунд, чаще опрашивать нечего.
const REFRESH_INTERVAL_MS = 30 * 1000;

const initialState = { branches: null };

const ACTION_SET_BRANCHES = 'offlineTokens/branches/ACTION_SET_BRANCHES';

function setBranches(branches) {
  return { type: ACTION_SET_BRANCHES, branches };
}

export async function loadBranches() {
  try {
    return setBranches(await listOfflineBranches(branchShape));
  } catch (err) {
    return setBranches(new ErrorCapsule(err, () => [
      setBranches(initialState.branches), loadBranches(),
    ]));
  }
}

// Тихое обновление: без сброса в null, иначе таблица моргает лоадером
// каждые полминуты.
async function refreshBranches() {
  try {
    return setBranches(await listOfflineBranches(branchShape));
  } catch (err) {
    return { type: 'offlineTokens/branches/ACTION_NOOP' };
  }
}

export function offlineBranchesReducer(state = initialState, action) {
  switch (action.type) {
    case ACTION_SET_BRANCHES:
      return { ...state, branches: action.branches };
    default: return state;
  }
}

const OfflineBranchesPage = connect(
  ({ offlineTokens }) => ({ branches: offlineTokens.branches.branches }),
)(class extends Component<OfflineBranchesPageViewProps> {
  constructor(props) {
    super(props);
    props.dispatch([setBranches(null), loadBranches()]);
  }
  componentDidMount() {
    this.timer = setInterval(() => this.props.dispatch(refreshBranches()), REFRESH_INTERVAL_MS);
  }
  componentWillUnmount() {
    clearInterval(this.timer);
    this.props.dispatch(setBranches(null));
  }
  render() {
    return (
      <OfflineBranchesPageView
        {...this.props}
        onRefresh={() => this.props.dispatch(refreshBranches())}
      />
    );
  }
});

export function offlineBranchesPageRoutes(): Routes {
  return [{
    title: 'Офлайн-каттер',
    path: '/offline/branches/',
    // В isEnabled приходит только isUser/isGuest/authState, isAdmin там нет.
    // Раздел и так виден в меню лишь админам, а сервер на всех запросах
    // требует админа и отвечает Access denied.
    isEnabled: ({ isUser }) => isUser,
    render: params => <OfflineBranchesPage {...sanitizeRouteParams(params, {})} />,
    nav: { isWide: true },
    design: null,
  }];
}
